if (!customElements.get('lmtd-delivery-estimate')) {
  customElements.define(
    'lmtd-delivery-estimate',
    class LmtdDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.freeThreshold, 10) || 0;
        this.standardPrice = this.dataset.standardPrice || '\u00A33.99';
        this.freeLabel = this.dataset.freeLabel || 'Free';

        var std = (this.dataset.standardDays || '3,5').split(',');
        var exp = (this.dataset.expressDays || '1,3').split(',');
        this.standardDays = [parseInt(std[0], 10), parseInt(std[1], 10)];
        this.expressDays = [parseInt(exp[0], 10), parseInt(exp[1], 10)];

        this.prices = {};
        var priceEl = this.querySelector('[data-lmtd-variant-prices]');
        if (priceEl) {
          try {
            this.prices = JSON.parse(priceEl.textContent);
          } catch (e) {
            this.prices = {};
          }
        }

        this.scope = this.closest('.product') || document;

        this.renderDates();
        this.refresh();

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            var variant = event && event.data && event.data.variant;
            this.refresh(variant ? variant.id : null);
          });
        }

        this.onChange = () => {
          setTimeout(() => this.refresh(), 0);
        };
        this.scope.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.scope && this.onChange) {
          this.scope.removeEventListener('change', this.onChange);
        }
      }

      addBusinessDays(date, days) {
        var result = new Date(date);
        var added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          var d = result.getDay();
          if (d !== 0 && d !== 6) added++;
        }
        return result;
      }

      format(date) {
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      }

      range(days) {
        var today = new Date();
        return (
          this.format(this.addBusinessDays(today, days[0])) +
          ' \u2013 ' +
          this.format(this.addBusinessDays(today, days[1]))
        );
      }

      renderDates() {
        var std = this.querySelector('[data-standard-dates]');
        var exp = this.querySelector('[data-express-dates]');
        if (std) std.textContent = this.range(this.standardDays);
        if (exp) exp.textContent = this.range(this.expressDays);
      }

      currentVariantId() {
        var input = this.scope.querySelector('.product-variant-id');
        return input ? input.value : null;
      }

      refresh(idFromEvent) {
        var id = idFromEvent || this.currentVariantId();
        if (!id) return;

        var price = this.prices[String(id)];
        if (typeof price !== 'number') return;

        var strike = this.querySelector('[data-standard-strike]');
        var amount = this.querySelector('[data-standard-amount]');
        if (!strike || !amount) return;

        if (price >= this.threshold) {
          strike.hidden = false;
          amount.textContent = this.freeLabel;
        } else {
          strike.hidden = true;
          amount.textContent = this.standardPrice;
        }
      }
    }
  );
}